<router-outlet />
<div *ngIf="loading" class="fixed inset-0 flex items-center justify-center backdrop-blur cursor-wait z-99">
  <mat-spinner></mat-spinner>
</div>
